import React from 'react';
import PropTypes from 'prop-types';
import {getErrorMessageFromData} from '../utils/manageApiErrorMessages';

//MUI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useTranslation} from 'react-i18next';

const AlertDialog = ({title, isOpen, onAccept, onCancel, additionalText = '', additionalData = {}}) => {

  const {t} = useTranslation();

  const handleCancel = () => onCancel();
  const handleDelete = () => onAccept();
  const titleStyle = {
    color: 'secondary.main',
    '& h2': {
      fontWeight: 900
    }
  };

  return <Dialog open={isOpen}>
    <DialogTitle sx={titleStyle}>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        <p>{additionalText}</p>
        <p>{getErrorMessageFromData(additionalData)}</p>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {onCancel && <Button onClick={handleCancel} color="secondary" variant='text'>
        {t('cancelar')}
      </Button>}
      {onAccept && <Button onClick={handleDelete} color="secondary">
        {t('aceptar')}
      </Button>}
    </DialogActions>
  </Dialog>;
};

AlertDialog.propTypes = {
  isOpen: PropTypes.bool,
  title: (props, propName, componentName) => {
    if (!props.title && !props.description) {
      return new Error(`One of props 'title' or 'description' was not specified in '${componentName}'.`);
    }
  },
  additionalText: PropTypes.string,
  additionalData: PropTypes.object,
  onAccept: PropTypes.func,
  onCancel: PropTypes.func
};

AlertDialog.defaultProps = {
  isOpen: true,
};

export default AlertDialog;